import {
  HorizontalRightsizingFormModelV2,
  WorkloadDetailsFormModel,
} from '../../../../_types';
import { WorkloadHpaFormSettings } from '../../_constants';

export const settingsRowDescriptions: Record<
  WorkloadHpaFormSettings,
  (prop: {
    formModel: WorkloadDetailsFormModel<HorizontalRightsizingFormModelV2>;
  }) => string[]
> = {
  basicBehavior: ({ formModel }) => [
    `Min: ${formModel.horizontalRightsizing.hpaSettings?.basicBehavior?.minReplicas}`,
    `Max: ${formModel.horizontalRightsizing.hpaSettings?.basicBehavior?.maxReplicas}`,
  ],
  metrics: ({ formModel }) => {
    const metrics = formModel.horizontalRightsizing?.hpaSettings?.metrics;
    const parts = [];
    if (metrics?.cpu !== null && metrics?.cpu !== undefined) {
      parts.push(`CPU: ${metrics.cpu}%`);
    }
    if (metrics?.memory !== null && metrics?.memory !== undefined) {
      parts.push(`Memory: ${metrics.memory}%`);
    }
    return parts.length ? parts : ['No Triggers'];
  },
  autoscalerBehavior: ({ formModel }) => {
    const behavior =
      formModel.horizontalRightsizing?.hpaSettings?.autoscalerBehavior;
    return [
      `Scale up stabilization: ${
        behavior?.scaleUp?.stabilizationWindowSeconds ?? 0
      } sec`,
      `Scale down stabilization: ${
        behavior?.scaleDown?.stabilizationWindowSeconds ?? 0
      } sec`,
    ];
  },
};
